import AwesomeLoaders from "../../../../pages/docs/code/rug";
import { DonateButton, StyledParent } from "../../../../pages/docs/code/donate";
import BMC from "../../../../images/bmc.png";
import Paypal from "../../../../images/paypal.png";
import Patreon from "../../../../images/patreon.png";
import Bhim from "../../../../images/bhim.png";
import * as React from 'react';
export default {
  AwesomeLoaders,
  DonateButton,
  StyledParent,
  BMC,
  Paypal,
  Patreon,
  Bhim,
  React
};